<button
  class="toggle htv-selectable"
  [class.no-pointer]="platformType === HTVPlatform.PHILIPS"
  [class.bg-primary]="!hidden"
  (click)="toggleHidden()">
  <img
    class="toggle__icon"
    [src]="'assets/images/icons/subtitles_' + (hidden ? 'white' : 'white') + '.svg'"
    alt="subtitles" />
</button>

<ng-container *ngIf="!hidden">
  <div class="menu">
    <div class="menu__body">
      <div class="menu__body__section">
        <div class="menu__body__section__title">
          <img class="menu__body__section__icon" src="assets/images/icons/subtitles.svg" alt="subtitles-languages" />
        </div>
        <div class="menu__body__section__content">
          <div
            *ngFor="let est of extendedSubtitleTracks"
            class="item htv-selectable"
            [ngClass]="isSubtitleEnabled && est.data.index === currentSubtitleTrack?.data?.index ? 'active' : ''"
            tabindex="-1"
            (click)="setSubtitleTrack(est.data)">
            <span>{{ est.nativeLanguage | titlecase }}</span>
            <span *ngIf="est.data.flags.indexOf(ChannelTrackDataFlags.HEARING_IMPAIRED) > -1">
              ({{ 'CHANNEL_SUBTITLE.CLOSED_CAPTION.FULL' | translate }})
            </span>
            <span *ngIf="est.data.flags.indexOf(ChannelTrackDataFlags.VISUAL_IMPAIRED) > -1">
              ({{ 'CHANNEL_SUBTITLE.AUDIO_DESCRIPTION.FULL' | translate }})
            </span>
          </div>
        </div>
      </div>
      <span class="menu__body__divider"></span>
      <div class="menu__body__section">
        <div class="menu__body__section__title">
          <img class="menu__body__section__icon" src="assets/images/icons/volume_up.svg" alt="audio-languages" />
        </div>
        <div class="menu__body__section__content">
          <div
            *ngFor="let eat of extendedAudioTracks"
            class="item htv-selectable"
            [ngClass]="eat.data.index === currentAudioTrack?.data?.index ? 'active' : ''"
            tabindex="-1"
            (click)="setAudioTrack(eat.data)">
            <span>{{ eat.nativeLanguage | titlecase }}</span>
            <span *ngIf="eat.data.flags.indexOf(ChannelTrackDataFlags.HEARING_IMPAIRED) > -1">
              ({{ 'CHANNEL_SUBTITLE.CLOSED_CAPTION.FULL' | translate }})
            </span>
            <span *ngIf="eat.data.flags.indexOf(ChannelTrackDataFlags.VISUAL_IMPAIRED) > -1">
              ({{ 'CHANNEL_SUBTITLE.AUDIO_DESCRIPTION.FULL' | translate }})
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="menu__title">{{ 'CHANNEL_SUBTITLE.MENU_TITLE' | translate }}</div>
  </div>
</ng-container>
